import axios from "axios"
import React, { useState } from "react"
import { useRouter } from "next/router"
import { useForm } from "react-hook-form"
import { Preloader } from "../universal/preloader"

type Props = {}

interface IInput {
  name: string
  email: string
  subject: string
  body: string
}

export const TechnicalForm: React.FC<Props> = () => {
  const router = useRouter()
  const [loading, setLoading] = useState(false)
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<IInput>()

  const onSUbmit = (data: IInput) => {
    const postData = {
      ...data,
      type: "technical",
    }

    setLoading(true)
    axios
      .post("/api/contact", postData)
      .then((res) => {
        if (res.status == 200) {
          router.push("/contact/success")
        } else {
          router.push("/contact/error")
        }
      })
      .catch((err) => {
        setLoading(false)
        router.push("/contact/error")
      })
  }

  return (
    <form acceptCharset="utf-8" className="contact-form" onSubmit={handleSubmit(onSUbmit)}>
      <label>your name {errors.name && <small className="error">(Required!)</small>}</label>
      <input type="text" {...register("name", { required: true })} required placeholder="Enter your name" />

      <label>email {errors.email && <small className="error">(Required!)</small>}</label>
      <input type="text" {...register("email", { required: true })} required placeholder="address@email.com" />

      <label>Issue {errors.subject && <small className="error">(Required!)</small>}</label>
      <input type="text" {...register("subject", { required: true })} required placeholder="Write a Issue" />

      <label>Message {errors.body && <small className="error">(Required!)</small>}</label>
      <textarea placeholder="Write your message" {...register("body", { required: true })} required className="input-text message-input" />

      <button type="submit" className="btn-lg-label bg-primary secondary">
        Submit
        {loading && <Preloader color="white" />}
      </button>
    </form>
  )
}
